import { Form, Formik } from 'formik';
import React from 'react';
import { initialValues, onSubmit, validationSchema } from './forgotPasswordFormikCodes.js';
import { Link, useNavigate } from 'react-router-dom';
import KeyIcon from '@mui/icons-material/Key';
import GetField from '../../components/GetField.jsx';

const ForgotPassword = () => {
    const navigate = useNavigate();

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, actions) => onSubmit(values, actions, navigate)}
            validationSchema={validationSchema}
            validateOnMount
        >
            {(formik) => {
                return (
                    <Form className="flex flex-col items-center px-2 py-3">
                        <div>
                            <KeyIcon sx={{ fontSize: "2.5rem" }} />
                        </div>
                        <h2 className="text-lg mb-5">تغییر رمز عبور</h2>
                        <div className="mb-4 w-full sm:w-3/4 md:w-3/5 max-w-screen-sm">
                            <GetField
                                control="input"
                                name="email_or_phone"
                                type="text"
                                placeholder="ایمیل یا شماره تلفن"
                                formik={formik}
                                fieldClass="dir-ltr"
                            />
                        </div>
                        <div className="mb-4 w-full sm:w-3/4 md:w-3/5 max-w-screen-sm">
                            <GetField
                                control="password"
                                name="new_password"
                                placeholder="رمز عبور جدید"
                                formik={formik}
                            />
                        </div>
                        <div className="mb-4 w-full sm:w-3/4 md:w-3/5 max-w-screen-sm">
                            <GetField
                                control="password"
                                name="confirm_password"
                                placeholder="تکرار رمز عبور جدید"
                                formik={formik}
                            />
                        </div>
                        <div className="mb-4 w-full sm:w-3/4 md:w-3/5 max-w-screen-sm">
                            <Link to="/auth/login" className="text-primary hover:underline">
                                    صفحه ورود ادمین
                            </Link>
                        </div>
                        <div className="w-full text-center mt-4">
                            <GetField
                                control="submitbutton"
                                disabledButton={true}
                                formik={formik}
                                text={"تغییر رمز عبور"}
                            />
                        </div>
                    </Form>
                );
            }}
        </Formik>
    );
}

export default ForgotPassword;
